import React, { Component } from 'react';

import Select from '../../../_common/Select';
import { components } from 'react-select';
import { setFilters } from '../../../../state/filterService';
import { getPimValue } from '../../../../utils/utils';

class ProductsFilterItem extends Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);
  }

  onChange(e) {
    const { dispatch, filter, filterKey } = this.props;
    const { activeFilters } = filter;

    const filtersSet = new Set();
    e.forEach((value) => filtersSet.add(value?.value));

    dispatch(
      setFilters({
        key: filterKey,
        value: Array.from(filtersSet),
      })
    );
  }

  render() {
    const { filter, filterKey, filteredProducts, site } = this.props;

    const availableFiltersSet = new Set();
    for (const product of filteredProducts) {
      if (Array.isArray(product[filterKey])) {
        for (const value of product[filterKey]) {
          if (getPimValue(value, site)) {
            availableFiltersSet.add(getPimValue(value, site));
          }
        }
      } else {
        if (getPimValue(product[filterKey], site)) {
          if (getPimValue(product[filterKey], site) !== 'None') {
            availableFiltersSet.add(getPimValue(product[filterKey], site));
          }
        }
      }
    }
    const availableFilters = Array.from(availableFiltersSet);

    const valueContainer = (props) => {
      const { selectProps } = props;
      const { activeFilters } = this.props.filter;

      let display;
      const value = activeFilters.length;

      if (selectProps.inputValue) {
        display = '';
      } else if (value) {
        display = `${selectProps.placeholder} (${value})`;
      } else {
        display = `${selectProps.placeholder}`;
      }

      return (
        <components.ValueContainer {...props}>
          {React.Children.toArray(props.children).filter(
            (child) => ['Input'].indexOf(child.type.name) >= 0
          )}
          {display}
        </components.ValueContainer>
      );
    };

    let selectedOptions = [];

    return (
      <div className="filters__filter-item">
        {filter.type === 'boolean' ? (
          <span className="filters__filter-item-checkbox">
            <input
              id={filterKey}
              type="checkbox"
              checked={filter.activeFilters[0] || false}
              onChange={(e) => {
                if (e.target.checked) {
                  this.onChange([{ value: true }]);
                } else {
                  this.onChange([]);
                }
              }}
            />
            <label htmlFor={filterKey}>{filter.label}</label>
          </span>
        ) : (
          <Select
            onChange={this.onChange}
            menuPlacement="auto"
            menuPosition="fixed"
            placeholder={filter.label}
            closeMenuOnScroll={true}
            isMulti={true}
            hideSelectedOptions={false}
            components={{
              ValueContainer: valueContainer,
            }}
            options={availableFilters.map((filter) => ({
              label: filter,
              value: filter,
            }))}
            value={filter.activeFilters.map((filter) => ({
              label: filter,
              value: filter,
            }))}
          />
        )}
      </div>
    );
  }
}

export default ProductsFilterItem;
